import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { CHARGE_CDN } from "../../../../utils/constants";
import "./index.less";
import { TabItem } from "../../types";
import { processOssImage } from "@/utils/image";

export interface HomeTabsBarRef {
  clickTab: (tabItem: TabItem) => void;
}

interface Props {
  firstShowTabKey?: number | null;
  showSubTitle?: boolean;
  showIcon?: boolean;
  tabItems: TabItem[];
  className?: string;
  changeActiveTab?: (tab: number) => void;
}

const HomeTabsBar = React.memo(
  forwardRef<HomeTabsBarRef, Props>(function App(
    {
      firstShowTabKey,
      showSubTitle = true,
      tabItems,
      className = "",
      changeActiveTab,
      showIcon,
    }: Props,
    ref,
  ) {
    const [hlTab, setHlTab] = useState(firstShowTabKey || -1);

    const clickTab = (tabItem: TabItem) => {
      setHlTab(tabItem?.key);
      if (changeActiveTab) {
        changeActiveTab(tabItem?.key);
      }
    };

    // 暴露 clickTab 方法给上层组件
    useImperativeHandle(ref, () => ({
      clickTab,
      setHlTab,
    }));

    useEffect(() => {
      if (firstShowTabKey) {
        setHlTab(firstShowTabKey);
      }
    }, [firstShowTabKey]);

    if (tabItems?.length <= 1) return null;
    return (
      <div
        className={`vip-home-tabs-bar ${className} ${showSubTitle && tabItems?.some((i) => i.subTitle) ? "vip-home-tabs-bar-with-sub-title" : ""}`}
      >
        {tabItems?.length > 0 &&
          tabItems.map((tabItem, index) => (
            <div
              className={`tab-pane ${
                tabItem?.key === hlTab
                  ? index === 0
                    ? "active-first"
                    : index === tabItems.length - 1
                      ? "active-last"
                      : "active"
                  : ""
              }  ${tabItems.length > 3 ? "more-tabs" : ""}`}
              key={index}
              style={{
                width: `${100 / tabItems.length}%`,
              }}
              onClick={() => clickTab(tabItem)}
            >
              <div className="tab-pane-title-container">
                <div
                  className={`title ${tabItem?.key === hlTab ? "value-card-title" : ""}`}
                >
                  {showIcon && tabItem?.key === hlTab && (
                    <img
                      alt=""
                      className="tab-pane-icon"
                      src={processOssImage(
                        `${CHARGE_CDN}/chargeVip/red_pack.png`,
                      )}
                    />
                  )}
                  {tabItem?.title}
                </div>
                {tabItem?.subTitle && showSubTitle && (
                  <div className={`sub-title`}>{tabItem?.subTitle}</div>
                )}
              </div>
            </div>
          ))}
      </div>
    );
  }),
);

export default HomeTabsBar;
